const deleteEquipmentServices = {
  toastr: 'Serviço Deletado'
};

export default deleteEquipmentServices;
